import { Type } from 'class-transformer';
import { FileInfoDisplayResultDto } from '../../../_models/file-info-display-result-dto';

export class SubmittedInvoiceResultDto {
    workflowId: number;
    checkNumber: string;
    communityId: number;
    community: string;
    status: string;
    vendor: string;
    vendorId: number;
    vendorCode: string;
    location: string;
    invoiceNumber: string;
    amount: number;
    hasNotes: boolean;

    @Type(() => Date)
    startTime: Date;

    @Type(() => Date)
    paymentDate: Date;

    @Type(() => FileInfoDisplayResultDto)
    invoiceFile: FileInfoDisplayResultDto;

    office: string;
}
